<template>
  <v-btn
    class="reset-button"
    @click="handleResetPreview"
    :title="title"
    size="small"
    variant="tonal">
    <v-icon size="x-large">mdi-sync</v-icon>
  </v-btn>
</template>
<script setup>
import { $http } from '../../../stores/http';

const props = defineProps(['channelUUID', 'title']);

const resetPreviewURL = `/dynamic_engine/reset_preview/${props.channelUUID}`;
async function handleResetPreview() {
  await $http('GET', resetPreviewURL);
}
</script>
<style scoped>
.reset-button[disabled] {
  /* cursor: not-allowed; */
  cursor: default;
  pointer-events: auto;
}
</style>
